var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "place",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.136,
    height: 15,
    viewBox: "0 0 12.136 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M59.933,2.608a6.056,6.056,0,0,0-9.958,0,6.057,6.057,0,0,0-.705,5.581,4.77,4.77,0,0,0,.879,1.452l4.406,5.175a.524.524,0,0,0,.8,0l4.4-5.173a4.775,4.775,0,0,0,.879-1.45A6.059,6.059,0,0,0,59.933,2.608Zm-.278,5.217a3.741,3.741,0,0,1-.692,1.133l0,0-4.006,4.706L50.945,8.958a3.743,3.743,0,0,1-.693-1.137A5.011,5.011,0,0,1,50.838,3.2a5.007,5.007,0,0,1,8.232,0A5.011,5.011,0,0,1,59.654,7.825Z",
    transform: "translate(-48.886)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(3.131 3.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M158.691,106.219a2.937,2.937,0,1,0,2.937,2.937A2.94,2.94,0,0,0,158.691,106.219Zm0,4.825a1.888,1.888,0,1,1,1.888-1.888A1.89,1.89,0,0,1,158.691,111.044Z",
    transform: "translate(-155.754 -106.219)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.d68a7eec.svg";
export { ForwardRef as ReactComponent };